export { default as DOMLocalization } from "./dom_localization.js";
export { default as Localization } from "./localization.js";
